export default {
  TeacherExamPeriod: {
    All: 'Tất cả',
    Checked: 'Đã chấm',
    Unchecked: 'Chưa chấm',
    StartTime: 'Thời điểm làm bài',
    FinishTime: 'Thời điểm nộp bài',
    TimeAmount: 'Thời gian làm bài',
    ExamAlert: 'Cảnh báo',
    TotalScore: 'Tổng điểm',
    CommentInput: 'Nhập nhận xét của giáo viên',
    MultipleChoiceScore: 'Trắc nghiệm',
    EssayScore: 'Tự luận',
    CheckStudentTest: 'Chấm bài',
    CompleteCorrect: 'Hoàn thành chấm bài',
    ReviewStudentTest: 'Xem lại',
    ExamTopic: 'Đề kiểm tra',
    StartTimeTopic: 'Thời gian mở đề',
    FinishTimeTimeTopic: 'Thời gian đóng đề',
    ExamTimeAmount: 'Khung thời gian kiểm tra',
    GiveChoiceScoreAfterFinish: 'Gửi kết quả Trắc nghiệm ngay sau khi HS làm bài',
    NotGiveChoiceScoreAfterFinish: 'Không gửi kết quả Trắc nghiệm ngay sau khi HS làm bài',
    ConcentrationExam: 'Học sinh làm bài cùng thời điểm',
    DispersionExam: 'Học sinh làm bài trong khoảng thời gian',
    StudentName: 'Học sinh',
    EditExamInfo: 'Sửa thông tin',
    OpenTopic: 'Mở đề',
    CloseTopic: 'Đóng đề',
    SendMark: 'Gửi điểm',
    RecallMark: 'Thu hồi điểm',
    AssignType: 'Đối tượng tham gia',
    EditStudentList: 'Chỉnh sửa danh sách',
    DeleteExamPeriodButton: 'Xóa',
    OpenTopicExamPeriodButton: 'Mở đề',
    CloseTopicExamPeriodButton: 'Đóng đề',
    Minute: 'phút',
    Student: 'Học sinh',
    IsJoin: 'Đã tham gia',
    IKnow: 'Đã hiểu',
    NotJoin: 'Chưa tham gia',
    YouMustMarkAllExameBeforeSendMark: 'Bạn cần hoàn thành chấm bài trước khi gửi điểm cho học sinh',
    NoticeFiveMinutesLeft: 'Đề kiểm tra <b>{title}</b></br> sẽ tự động đóng trong 5 phút nữa',
    TimeLeft: 'Thời gian còn lại',
    AutoRoundMark: 'Tự động làm tròn điểm',
    SettingRoundMark: 'Thiết lập làm tròn',
    SettingRoundMarkPoint: 'Thiết lập làm tròn điểm',
    MarkRoundToOne: 'Điểm nguyên (Ví dụ: 9.4 -> 9; 9.5 -> 10)',
    MarkRoundToZeroDotOne: 'Lấy một chữ sau dấu phẩy</br>(Ví dụ: 9.75 -> 9.8; 9.74 -> 9.7)',
    MarkRoundToZeroDotOneflex: 'Lấy một chữ sau dấu phẩy (Ví dụ: 9.75 -> 9.8; 9.74 -> 9.7)',
    MarkRoundToZeroDotOneForCreate: 'Lấy một chữ sau dấu phẩy',
    MessageCloseTopicExamPeriod: 'Sau <b>{minuteLeft}</b> phút <b>{secondLeft}</b> giây đến thời gian dự kiến đóng đề.</br> Có <b>{submitStudentAmount}</b>/<b>{totalStudent} học sinh</b> đã nộp bài. Bạn có chắc muốn đóng đề sớm không?',
    QuestionShuffle: 'Ngẫu nhiên thứ tự câu hỏi',
    AnswerShuffle: 'Ngẫu nhiên thứ tự đáp án',
    ExamStoreShuffle: 'Trộn đề kiểm tra',
    ShuffleDescription: 'Số lượng bộ đề cần trộn',
    AmountOfShuffle: 'Nhập số lượng bộ đề cần trộn (tối đa 10 bộ)',
    EssayShuffle: 'Trộn câu tự luận',
    GroupShuffle: 'Trộn câu hỏi nhóm',
    ViewStudentExamStore: 'Chi tiết đề bài',
    TimeExamAlert: 'Thời gian',
    ContentAlert: 'Nội dung',
    MessageAlert: 'Thiết bị',
    AlertHeader: 'Cảnh báo vi phạm',
    ListTitle: 'Danh sách bài kiểm tra'
  },

  ExamPeriod: {
    NoExamPeriod: 'Chưa có công việc nào',
    NoExam: 'Chưa có bài kiểm tra',
    NoMission: 'Chưa có nhiệm vụ',
    NoSearchExamPeriod: 'Không tìm thấy bài kiểm tra',
    NoSearchExamTopic: 'Không tìm thấy đề kiểm tra',
    DataEmpty: 'Chưa có dữ liệu',
    NoSearchMission: 'Không tìm thấy nhiệm vụ',
    Time: 'Chọn giờ',
    Date: 'Chọn ngày',
    TextExamTitle: 'Nhập tên bài KT',
    Grade: 'Khối',
    Subject: 'Môn',
    Class: 'Lớp',
    Status: 'Trạng thái',
    AssignAllStudent: 'Giao cho toàn bộ học sinh trong lớp ',
    StudentJoin: 'Học sinh tham gia',
    StudentNotJoin: 'Học sinh không tham gia',
    ChooseClass: 'Chọn lớp',
    ChooseAllStudent: 'Chọn tất cả',
    CancelChooseAll: 'Bỏ chọn tất cả',
    SearchStudent: 'Tìm kiếm học sinh',
    ExampleExamTitle: 'Ví dụ: Bài kiểm tra HKI - {subjectName} - {gradeName}',
    ComposeDeadline: 'Hạn soạn đề',
    StartTimeExam: 'RefStartTimeExam',
    EndTimeExam: 'RefEndTimeExam',
    EndDateExam: 'RefEndDateExam',
    NoteStudent: 'Ghi chú cho học sinh',
    WriteNote: 'Viết ghi chú',
    MeaningNote: 'Cung cấp thêm thông tin về bài kiểm tra hay yêu cầu khác cho học sinh (link Zoom, Microsoft Teams...)',
    ViewExamComposeNotify: 'Bạn chỉ có thể xem đề sau khi bài kiểm tra bắt đầu',
    ViewStudentExam: 'Xem bài làm',
    Assignment: 'Phân công giáo viên chấm bài',
    NotAssignment: 'Không phân công giáo viên chấm bài',
    ToolNotAssignment: 'Đề kiểm tra của bạn có bao gồm <b>{qtyQuestionHint} câu tự luận</b>. Bạn có chắc chắn muốn chọn không phân công giáo viên chấm bài không?',
    AssignmentDescription: 'Giáo viên sẽ gửi điểm và kết quả sau khi chấm',
    EssayQuestion: '(phù hợp với điểm kiểm tra có các câu hỏi tự luận)',
    MunltipleQuestion: '(phù hợp với đề kiểm tra trắc nghiệm hoàn toàn)',
    NotAssignmentDescription: 'GVCN, GVBM xem điểm và đáp án khi bài kiểm tra kết thúc',
    ExamPlanInSchool: 'Kế hoạch kiểm tra của Nhà trường',
    ExamPlanByTeacher: 'Cá nhân tổ chức kiểm tra',
    TeacherExamPeriod: 'Giáo viên tự tổ chức kiểm tra',
    TeacherMission: 'Danh sách công việc sắp tới',
    CreateTeacherExamPeriod: 'Tổ chức kiểm tra nhanh với 2 bước',
    FastWithTwoStep: 'Nhanh chóng với 2 bước:',
    PlanTeacherExamPeriod: 'Kế hoạch tổ chức kiểm tra',
    ManagerListExamPeriod: 'Quản lý danh sách bài kiểm tra trực tuyến',
    NearestExam: 'Bài kiểm tra gần đây',
    AllMonths: 'Tất cả tháng',
    School: 'Toàn trường',
    Student: '{studentQuantity} học sinh',
    Scope: 'Phạm vi',
    RootExamCode: 'Đề số {sortOrder} (gốc)',
    ExamCode: 'Đề số {sortOrder}',
    // PBac
    NotSetYet: 'Chưa thiết lập'
  },

  // PBac
  CorrectingExam: {
    Progress: '{totalCorrected}/{totalStudent}',
    FlagMarked: 'Đánh dấu <b>Đã chấm</b>',
    FlagNotMark: 'Đánh dấu <b>Chưa chấm</b>',
    ChoiceQuestion: 'Câu trắc nghiệm:',
    EssayQuestion: 'Câu tự luận:',
    Point: '{point} điểm',
    NoPointYet: 'Chưa có điểm',
    SentenceAndPoint: 'Câu {sentence}: ({point} điểm)',
    InputPoint: 'Ghi điểm',
    MaxPoint: 'Điểm tối đa',
    ChangePoint: 'Sửa điểm',
    Comment: 'Nhận xét',
    InputComment: 'Nhập nhận xét',
    TeacherComment: 'Nhận xét của giáo viên',
    TeacherCommentPlaceHolder: 'Nhập nhận xét toàn bài tại đây',
    PointCantHaveCharacter: 'Điểm không được có kí tự',
    PointCantBeGreaterThanMaxPoint: 'Điểm không được lớn hơn điểm tối đa',
    PointCantBeNull: 'Điểm không được để trống',
    FinishCorectExamMessage: 'Còn {unfinish}/{total} học sinh chưa được chấm bài. Bạn có muốn tiếp tục không?',
    EssayOnly: 'Chỉ xem câu tự luận',
    SendExamResultSuccess: 'Gửi điểm thành công',
    SendExamResultFail: 'Gửi điểm thất bại',
    RecallExamResultSuccess: 'Thu hồi điểm thành công',
    RecallExamResultFail: 'Thu hồi điểm thất bại',
    ViewStudentExam: 'Chi tiết bài làm {className}'
  },

  // VHSon
  AdminExamPeriod: {
    Monitor: 'Giám sát',
    Statistical: 'Thống kê',
    AssignMark: 'Phân công chấm bài',
    AssignMonitor: 'Phân công coi kiểm tra',
    ExamTopic: 'Đề kiểm tra',
    CommonInformation: 'Thông tin chung'
  }
}
